<template>
  <v-container fluid>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Dashboard de Eficiencias {{ dayjs(mes).format('YYYY-MM') }}</v-card-title>
          <v-card-text>

            <v-combobox outlined multiple chips
                        class="mt-2"
                        v-model="agenciasSelected"
                        item-text="nombre"
                        return-object
                        :items="getUniqueAgencias"
                        label="Agencias"
                        clearable
            ></v-combobox>
            <v-combobox outlined multiple chips
                        class="mt-2"
                        v-model="comprasSelected"
                        item-text="nombre"
                        return-object
                        :items="getUniqueCompras"
                        label="Compras"
                        clearable
            ></v-combobox>

            <v-btn :disabled="!hayAgenciasSeleccionadas" :loading="comprasDeAgenciasLoading" color="primary" @click="fetchCompasDeAgenciasSeleccionadas">Buscar compras de agencias seleccionadas</v-btn>

          </v-card-text>
        </v-card>

      </v-col>

      <v-col cols="12" v-for="compra in comprasSelected" :key="compra.id">
        <v-card>
          <v-card-title>{{ compra.nombre }}</v-card-title>
          <v-card-text>

            <v-data-table
                :items="getItemsByCompra(compra.nombre)"
                :headers="headers"
                :loading="loading"
                disable-pagination
                hide-default-footer
            >

              <template v-slot:item.Capital="{item}">
                {{ currency }}{{ item.Capital.toLocaleString('es-AR') }}
              </template>

              <template v-slot:item.Intereses="{item}">
                {{ currency }}{{ item.Intereses.toLocaleString('es-AR') }}
              </template>

              <template v-slot:item.Total="{item}">
                {{ currency }}{{ item.Total.toLocaleString('es-AR') }}
              </template>

              <template v-slot:item.Recupero="{item}">
                {{ currency }}{{ item.Recupero.toLocaleString('es-AR') }}
              </template>

              <template v-slot:item.EficienciaCapital="{item}">
                {{ (item.Recupero / item.Capital * 100).toFixed(2) }}%
              </template>

              <template v-slot:item.EficienciaIntereses="{item}">
                {{ (item.Recupero / item.Intereses * 100).toFixed(2) }}%
              </template>

              <template v-slot:item.EficienciaTotal="{item}">
                {{ (item.Recupero / item.Total * 100).toFixed(2) }}%
              </template>


            </v-data-table>

          </v-card-text>
        </v-card>

      </v-col>

    </v-row>

  </v-container>
</template>

<script>

import ReporteStockProvider from "@/modules/cobrox/providers/ReporteStockProvider";
import EficienciaProvider from "@/modules/cobrox/providers/EficienciaProvider";
import dayjs from "dayjs";
import CurrencyMixin from "@/modules/cobrox/mixins/CurrencyMixin";

export default {
  name: "DashboardEficienciaPage",
  mixins: [CurrencyMixin],
  data() {
    return {
      reporteStockDashboard: null,
      loading: false,
      comprasDeAgenciasLoading: false,
      items: [],
      mes: dayjs().startOf('month'),
      comprasSelected: [],
      agenciasSelected: [],
      headers: [
        {text: 'Agencia', value: 'Agencia'},
        // {text: 'Compra', value: 'Compra'},
        {text: 'DNI Asignados', value: 'CantidadPersonas'},
        {text: 'Capital', value: 'Capital'},
        // {text: 'Intereses', value: 'Intereses'},
        {text: 'Total', value: 'Total'},
        {text: 'DNI Recupero', value: 'DniUnicosCobranza'},
        {text: 'Recupero', value: 'Recupero'},
        {text: 'Eficiencia Capital', value: 'EficienciaCapital'},
        // {text: 'Eficiencia Intereses', value: 'EficienciaIntereses'},
        {text: 'Eficiencia Total', value: 'EficienciaTotal'},
      ]
    }
  },
  async created() {
    await this.findReporteStockDashboard()
    this.loadComprasFromLocalStorage()
    this.loadAgenciasFromLocalStorage()
    await this.fetchEficiencia()
  },
  computed: {
    hayAgenciasSeleccionadas() {
      return this.agenciasSelected.length > 0
    },
    getUniqueCompras() {
      if (!this.reporteStockDashboard) return [];
      const items = this.reporteStockDashboard.data.items;
      const mapCompras = new Map();

      items.forEach(item => {
        if (!mapCompras.has(item.CompraId)) {
          mapCompras.set(item.CompraId, {
            id: item.CompraId,
            nombre: item.Compra
          });
        }
      });

      return Array.from(mapCompras.values());
    },
    getUniqueAgencias() {
      if (!this.reporteStockDashboard) return [];
      const items = this.reporteStockDashboard.data.items;
      const mapAgencias = new Map();

      items.forEach(item => {
        if (!mapAgencias.has(item.AgenciaId)) {
          mapAgencias.set(item.AgenciaId, {
            id: item.AgenciaId,
            nombre: item.Agencia
          });
        }
      });

      return Array.from(mapAgencias.values());
    },
    getItemsByCompra() {
      return (compra) => {
        return this.items.filter(item => item.Compra === compra &&
            (this.agenciasSelected.length === 0 || this.agenciasSelected.some(a => a.nombre === item.Agencia))
        );
      }
    }
  },
  watch: {
    comprasSelected: {
      handler(newVal) {
        this.saveComprasToLocalStorage(newVal)
      },
      deep: true
    },
    agenciasSelected: {
      handler(newVal) {
        this.saveAgenciasToLocalStorage(newVal)
      },
      deep: true
    }
  },
  methods: {
    dayjs,

    saveComprasToLocalStorage(compras) {
      try {
        localStorage.setItem('dashboardEficiencia_comprasSelected', JSON.stringify(compras))
      } catch (error) {
        console.error('Error saving compras to localStorage:', error)
      }
    },

    loadComprasFromLocalStorage() {
      try {
        const savedCompras = localStorage.getItem('dashboardEficiencia_comprasSelected')
        if (savedCompras) {
          const parsedCompras = JSON.parse(savedCompras)
          // Validar que las compras guardadas aún existen en las compras disponibles
          const availableCompras = this.getUniqueCompras
          const validCompras = parsedCompras.filter(savedCompra =>
              availableCompras.some(availableCompra => availableCompra.id === savedCompra.id)
          )
          this.comprasSelected = validCompras
        }
      } catch (error) {
        console.error('Error loading compras from localStorage:', error)
        // Si hay error, limpiar el localStorage
        localStorage.removeItem('dashboardEficiencia_comprasSelected')
      }
    },

    saveAgenciasToLocalStorage(agencias) {
      try {
        localStorage.setItem('dashboardEficiencia_agenciasSelected', JSON.stringify(agencias))
      } catch (error) {
        console.error('Error saving agencias to localStorage:', error)
      }
    },

    loadAgenciasFromLocalStorage() {
      try {
        const savedAgencias = localStorage.getItem('dashboardEficiencia_agenciasSelected')
        if (savedAgencias) {
          const parsedAgencias = JSON.parse(savedAgencias)
          // Validar que las agencias guardadas aún existen en las agencias disponibles
          const availableAgencias = this.getUniqueAgencias
          const validAgencias = parsedAgencias.filter(savedAgencia =>
              availableAgencias.some(availableAgencia => availableAgencia.id === savedAgencia.id)
          )
          this.agenciasSelected = validAgencias
        }
      } catch (error) {
        console.error('Error loading agencias from localStorage:', error)
        // Si hay error, limpiar el localStorage
        localStorage.removeItem('dashboardEficiencia_agenciasSelected')
      }
    },

    async findReporteStockDashboard() {
      try {
        this.loading = true
        const r = await ReporteStockProvider.findReporteStockDashboard()
        this.reporteStockDashboard = r.data.findReporteStockDashboard
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }

    },
    async fetchEficiencia() {
      try {
        this.loading = true
        const r = await EficienciaProvider.eficienciaAgencia(this.mes, this.reporteStockDashboard.id)
        this.items = r.data.eficienciaAgencia
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async fetchCompasDeAgenciasSeleccionadas(){
        try {
          this.comprasDeAgenciasLoading = true
          const r = await EficienciaProvider.obtenerComprasDeAgenciasSeleccionadas(this.agenciasSelected.map(a => a.id))
          const comprasDeAgencias = r.data.obtenerComprasDeAgencias.comprasDeAgencias
          const validCompras = this.getUniqueCompras.filter(compra =>
              comprasDeAgencias.some(id => id === compra.id)
          )
          this.comprasSelected = validCompras
        } catch (e) {
          console.error(e)
        } finally {
          this.comprasDeAgenciasLoading = false
        }
    }
  }
}
</script>

<style scoped>

</style>
